package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.data.repository.DashboardRepository
import br.com.texeratx.boardgametimeapp.ui.screens.dashboard.DashboardViewModel
import org.koin.dsl.module

val dashboardModule = module {

    factory { DashboardRepository(get(), get()) }
    factory { DashboardViewModel(get()) }
}
